import { useLayoutEffect, useRef, useState } from "react"
import Tooltip from "@mui/material/Tooltip"

// One line capped in width so a long value can't stretch the column; when it
// is actually cut off, hovering shows every entry of `lines` in a bubble.
// `children` replaces the plain text (e.g. an inline-edit cell).
const ClampedText = ({ lines, maxWidth = 200, children }) => {
  const ref = useRef(null)
  const [truncated, setTruncated] = useState(false)
  const text = lines.join("; ")

  useLayoutEffect(() => {
    const el = ref.current
    setTruncated(!!el && el.scrollWidth > el.clientWidth)
  }, [text])

  if (!lines.length) return "—"
  return (
    <Tooltip
      title={truncated ? <span style={{ whiteSpace: "pre-line" }}>{lines.join("\n")}</span> : ""}
      arrow
      placement="top"
    >
      <span
        ref={ref}
        style={{ display: "block", maxWidth, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
      >
        {children ?? text}
      </span>
    </Tooltip>
  )
}

export default ClampedText
